import { render, staticRenderFns } from "./NewPattern.vue?vue&type=template&id=04ac0927&scoped=true&"
import script from "./NewPattern.vue?vue&type=script&lang=js&"
export * from "./NewPattern.vue?vue&type=script&lang=js&"
import style0 from "./NewPattern.vue?vue&type=style&index=0&id=04ac0927&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ac0927",
  null
  
)

export default component.exports